import { Component } from 'shimmer'

import { Renderer } from './Renderer'

import {
  Scene,
  Vector3,
  Vector2,
  AxesHelper,
} from 'three'

import { PerspectiveCamera } from '@/webGL/cameras'
import { emitter } from '@/utils/emitter'

class WebGL extends Component {
  constructor () {
    super()

    this.resize = this.resize.bind(this)
    this.onQuality = this.onQuality.bind(this)

    this.scene = new Scene()

    this.camera = new PerspectiveCamera(50, 1, 1, 1000)
    this.camera.far = 2000
    this.camera.lookAt( new Vector3(0, 0, 0) )

    this.renderer = new Renderer(this.scene, this.camera)

    emitter.on('level:change', this.onQuality)

    this.start()
  }

  update () {
    this.camera.update()
    this.renderer.update()
  }

  start () {
    this.resize()
  }

  resize (args = {}) {
    args.width = args.width !== void 0 ? args.width : window.innerWidth
    args.height = args.height !== void 0 ? args.height : window.innerHeight
    this.renderer.resize(args)
  }

  onQuality () {
    this.renderer.renderQuality()
    // check if argument should be send here
    this.resize()
  }

  onDestroy () {
    this.destroy()
    this.renderer.onDestroy()
  }

  set el (el) {
    this.container = el
    this.container.appendChild(this.renderer.canvas)
  }
}

export const webGL = new WebGL()